import React, { useState, useRef } from 'react';
import { FormControl, Select, Checkbox, TableHead, Link, MenuItem, Paper, Popover, Table, TableBody, TableCell, TableContainer, TextField, TableRow } from '@mui/material'
import { useEffect } from 'react';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Container, Button, Stack, Typography, Card, CardContent, Tab, Box } from '@mui/material';
import { Grid } from '@mui/material';


export default function QualityReports() {
    const [tabValue, setTabValue] = React.useState('1');

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    return(
        <>
        <Container maxWidth="xxl">

<Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
    <Typography variant="h4" gutterBottom>
      Quality Report  
    </Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
      <>
        <Stack direction="row" spacing={1}>
        <Button
          color="primary"
          href="https://app.powerbi.com/Redirect?action=OpenApp&appId=b19056e8-31dd-4973-b895-f6c5c454929d&ctid=b039bf25-167f-443d-bd6e-11d07d669077"
          target="blank"
          rel="noopener noreferrer"
        
      >
          Click Here
      </Button>
        </Stack>
      </>
    </Stack>
  </Stack>

<Card>
<CardContent>

     <Grid container >
   
             <Grid item xs={12} lg={12}>
                 <TabContext value={tabValue}>
                     <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                         <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                             <Tab label="Quality Module" value="1" />
                             
                         </TabList>
                     </Box>
                     <TabPanel value="1">
                         <Grid item xs={12} lg={12}>
                          
                         <iframe title="Quality Module" width="100%" height="540" src={process.env.REACT_APP_QUALITY}
              frameborder="0" allowFullScreen="true"></iframe>
                           </Grid>
                       </TabPanel>
                       
                  </TabContext>
              </Grid>
          </Grid >

  {/* <Grid Container>
      <Typography gutterBottom variant='h5'>PIT Report</Typography>
      <Grid item xs={12} lg={12}>

          <iframe title="Stakeholder_report" width="100%" height="540" src="
https://app.powerbi.com/view?r=eyJrIjoiYmI4Y2YwZTktZTEwNC00OWQyLTliMDQtMWRjOGE0NzIxNzVkIiwidCI6ImIwMzliZjI1LTE2N2YtNDQzZC1iZDZlLTExZDA3ZDY2OTA3NyJ9"
              frameborder="0" allowFullScreen="true"></iframe>
      </Grid>
      <Grid item xs={12} lg={12}>
          <Button
          variant="outlined"
          color="primary"
          href="https://app.powerbi.com/Redirect?action=OpenApp&appId=86285238-d875-4a2f-87bc-2f73e9c2f989&ctid=b039bf25-167f-443d-bd6e-11d07d669077"
          style={{ padding: '10px 20px', fontSize: '1em' }}
      >
          Click Here
      </Button>

      </Grid>
  </Grid> */}
</CardContent>
</Card>
</Container>
</>
    );
}